import React from 'react';
import { connect } from 'react-redux';

import Stickersheet from '../components/demo/Stickersheet';

import MainContent from '../components/layout/MainContent';
import Title from '../components/typography/Title';

import { createFetchingView } from '../helpers/views';

class DemoView extends React.PureComponent {
  renderContent() {
    return (
      <MainContent
        id="DemoView"
        style={{ maxWidth: 1416 }}
        className="sk-fade-in-quarter-second"
      >
        <Title>Demo</Title>
        <Stickersheet {...this.props} />
      </MainContent>
    );
  }

  render() {
    if (this.props.isReady) {
      return this.renderContent();
    }

    return null;
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: false,
  ...ownProps,
});

export default connect(mapStateToProps)(createFetchingView(DemoView));



// WEBPACK FOOTER //
// ./src/views/DemoView.js